<template>
  <el-collapse
    v-model="p[`${listArr.id}-activeNames`]"
    accordion
    @change="onChange"
  >
    <el-collapse-item
      :title="$t('widgets_basic_article_classification_edit_327')"
      name="title"
    >
      <my_title_combination :infor="infor"></my_title_combination>
    </el-collapse-item>
    <el-collapse-item
      :title="$t('widgets_basic_article_classification_edit_328')"
      name="margin"
    >
      <my_margin
        :title="$t('widgets_basic_atlas_catalog_edit_427')"
        titleWidth="60"
        :marginTop.sync="module_infor.marginTop"
        :marginBottom.sync="module_infor.marginBottom"
        :marginLeft.sync="module_infor.marginLeft"
        :marginRight.sync="module_infor.marginRight"
      ></my_margin>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import i18n from '../../../language/index'

import p from '../p'

export default {
  name: 'title_margin',
  data () {
    return {
      p: {}
    }
  },
  created () {
    this.p = p.initData.call(this)
  },
  computed: {
    infor () {
      return this.$store.state.app.module_Data.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    },
    module_infor () {
      return this.$store.state.app.module_Data.data[
        this.$store.state.app.view_pattern + "_infor"
      ];
    },
    listArr () {
      return this.$store.state.app.module_Data.data.listArr;
    }
  },
  methods: {
    onChange (v) {
      p.initData.call(this, [v])
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/widgets/basic_plugin_code/components/title_margin.vue